import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 90_000,
});

// Attach Bearer token from localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("saludia_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Ocurrió un error inesperado.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" · ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Extract Spanish field-level errors from a 422 response so the UI can show
// them beside the input. Returns { "campo.subcampo": "mensaje", ... } and a
// summary string for the generic toast. Compatible with our backend's Spanish
// translator (`validation_errors_es.py`) which emits {field, msg}.
export function extractFieldErrors(err) {
  const detail = err?.response?.data?.detail;
  if (!Array.isArray(detail)) return { fieldErrors: {}, summary: formatApiError(err) };
  const fieldErrors = {};
  const messages = [];
  for (const e of detail) {
    if (!e || typeof e !== "object") continue;
    const key =
      e.field ||
      (Array.isArray(e.loc)
        ? e.loc.filter((s) => s !== "body" && typeof s === "string").join(".")
        : "");
    if (key && !fieldErrors[key]) fieldErrors[key] = e.msg;
    if (e.msg) messages.push(e.msg);
  }
  return { fieldErrors, summary: messages.join(" · ") };
}
